import React, { useEffect, useState, useMemo, useRef } from "react";

import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import Loader from "../../../components/Loader/Loader";
import { Link, useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import axios from "axios";
import JsBarcode from "jsbarcode";
import jsPDF from "jspdf";
import { toastError, toastSuccess } from "../../../common/Toast";
import {
  DATA_EXPORT,
  ERROR_MESSAGE,
  SUCCESS_MESSAGE,
} from "../../../common/Constant";
import * as XLSX from "xlsx";

const SaleBarcodeLabel = () => {
  const paramObject = useParams();
  const [formValues, setFormValues] = useState([]);
  const barcodeRefs = useRef([]);
  const barcodeRequestParam = localStorage.getItem("BarcodeRequestParam");
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState([]);
  const token = localStorage.getItem("Token");
  const settingids = localStorage.getItem("barcode-settings");
  const [selectedValue, setSelectedValue] = useState([]);

  const [placeHolder, setPlaceHolder] = useState("Load Selected Values");
  // const [selectDropdown, setSelectDropdown] = useState([]);
  const [id, setId] = useState(0);
  const [data, setData] = useState({
    inputValue: "",
    width: 1,
    height: 20,
    fontSize: 15,
    zeroFill: 10,
  });

  const selectStyles = {
    control: (provided) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
    }), // dropdown input css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(0, 0, 0, 0.1)",
      position: "absolute",
      background: "#f8f8f8",
      width: "100%",
      zIndex: 99,
    }), // dropdown menu css
  };

  const barcodeElements = useRef([]);
  const handleChange = (event) => {
    setData({ ...data, [event.target.name]: event.target.value });
  };
  console.log("data=====>", data);
  // Function for generating the barcode
  const generateBarcodes = () => {
    Object.keys(barcodeRefs.current).forEach((saleId) => {
      barcodeRefs.current[saleId].forEach((barcodeElement, index) => {
        const barcodeValue = `${saleId}`;
        const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");
        JsBarcode(barcodeElement, paddedBarcodeValue, {
          width: data.width,
          height: data.height,
          fontSize: data.fontSize,
          displayValue: true,
          fontoptions: "bold",
          textAlign: "center",
          font: "monospace",
          textPosition: "bottom",
          textMargin: 2,
          margin: 10,
          marginTop: undefined,
          marginBottom: undefined,
          marginLeft: undefined,
          marginRight: undefined,
          format: "CODE128",
          valid: () => true,
          background: "#ffffff",
          lineColor: "#000000",
          padding: data.zeroFill,
        });
      });
    });
  };

  const resetpage = () => {
    window.location.reload();
    localStorage.removeItem("barcode-settings");
  };
  //Function for export excel
  const handleExcelExport = () => {
    try {
      const data = formValues.length > 0 ? formValues : [];
      //const paddedBarcodeValue = barcodeValue.padStart(data.zeroFill, "0");

      // Create a new workbook
      const workbook = XLSX.utils.book_new();

      // Convert the data to a worksheet
      const worksheet = XLSX.utils.json_to_sheet(data);

      // Add the worksheet to the workbook
      XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

      // Save the workbook as an Excel file
      XLSX.writeFile(workbook, `sale_barcode_.xlsx`);
      toastSuccess(DATA_EXPORT);
    } catch {
      toastError(ERROR_MESSAGE);

      //setLoading(false);
    }
  };

  const downloadPdf = () => {
    const pdf = new jsPDF();
    let pageWidth = pdf.internal.pageSize.getWidth();
    let pageHeight = pdf.internal.pageSize.getHeight();
    let currentX = 10;
    let currentY = 10;

    formValues.forEach((item) => {
      const barcodeElements = barcodeRefs.current[item.SaleId];
      if (barcodeElements && barcodeElements.length > 0) {
        const barcodeElement = barcodeElements[0]; // Assuming you want only the first barcode for each SaleId
        if (barcodeElement !== null) {
          const imgData = barcodeElement.toDataURL("image/png");
          pdf.addImage(imgData, "PNG", currentX, currentY);

          // Calculate the new position for the next barcode
          currentX += data.width + 20; // Adjust the value as needed
          if (currentX + data.width + 20 > pageWidth) {
            currentX = 10;
            currentY += data.height + 20; // Adjust the value as needed
            if (currentY + data.height + 20 > pageHeight) {
              pdf.addPage();
              currentX = 10;
              currentY = 10;
            }
          }
        }
      }
    });

    pdf.save("barcodes.pdf");
  };

  // useEffect for getting the selected data
  useEffect(() => {
    axios
      .get(`${config.generalBaseUrl}/generals/barcodelisting`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("hello", res.data.ResponseData);
        setOptions(res.data.ResponseData);
        setLoading(false);
        generateBarcodes();
        // handleLoadSettings();
        console.log(options);
        res.data.ResponseData.map((data) => {
          if (settingids?.includes(data?.ID)) {
            console.log("id--->", data?.ID);

            setSelectedValue({
              value: data?.ID,
              label: data?.SaveAs_Name,
            });
            //handleUpdate({ value: data?.Barcode_Id, label: data?.SaveAs_Name });
          }
        });
      });

    axios
      .get(
        `${config.salesconfigBaseUrl}/sales/salebarcodeslist?saleid=${paramObject.id}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setFormValues(res.data.ResponseData);
        setTimeout(function () {
          generateBarcodes();
        }, 2000);
      });
  }, []);

  // Function for setting the value and updating the data
  const handleUpdate = (event) => {
    const selectedOption = options.find(
      (option) => option.value === event.value
    );
    setSelectedValue(event);
    console.log("he", event);
    axios
      .get(
        `${config.generalBaseUrl}/generals/barcodeselectbyid?id=${event.value}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        setId(res.data.ResponseData[0]?.ID);

        const data = {
          width: res.data.ResponseData[0].BarcodeImageWidth,
          height: res.data.ResponseData[0].BarcodeImageHeight,
          fontSize: res.data.ResponseData[0].BarcodeImageFontSize,
          zeroFill: res.data.ResponseData[0].ZerofillBarcode,
          inputValue: res.data.ResponseData[0].SaveAs_Name,
        };
        console.log("inputValue==>", res.data.ResponseData.SaveAs_Name);
        setData(data);
        setTimeout(() => generateBarcodes(), 2000);
        console.log("dhhjgd===>", data);
        setTimeout(()=>generateBarcodes(),2000)
      })
      .catch((err) => {});
  };

  //Function for inserting the data
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (
      data.inputValue == null ||
      data.inputValue == undefined ||
      data.inputValue == ""
      // id == id
    ) {
      generateBarcodes();
    } else {
      try {
        const allDataToSend = {
          ID: id,
          BarcodeImageWidth: data.width,
          BarcodeImageHeight: data.height,
          BarcodeImageFontSize: data.fontSize,
          ZerofillBarcode: data.zeroFill,
          SaveAs_Name: data.inputValue,
        };
        const response = await axios.post(
          `${config.generalBaseUrl}/generals/barcodeupsert`,
          allDataToSend,
          {
            headers: {
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",
              Authorization: token,
            },
          }
        );
        generateBarcodes();
        localStorage.setItem(
          "barcode-settings",
          JSON.stringify(response.data.ResponseID)
        );
        console.log("res", response.data.ResponseData[0]);
        console.log("name", response.data.ResponseData[0].SaveAs_Name);
        console.log("ID", response.data.ResponseData[0].ID);
        const optionsList = {
          value: response.data.ResponseData[0].ID,
          label: response.data.ResponseData[0].SaveAs_Name,
        };
        setSelectedValue(optionsList);
        console.log("option", selectedValue);

        // window.location.reload();
      } catch (error) {
        console.error(error);
      }
      setLoading(false);
    }
  };

  console.log("selectedValue ==>", selectedValue);
  console.log("formvaluesssss", formValues);
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col">
                <h3 className="page-title">Sales</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to="/sales"> Sales List</Link>
                  </li>
                  <li className="breadcrumb-item active">
                    Sales Barcode Label
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <br />
          <br />
          <div className="card">
            <div className="card-body">
              {/* input field */}

              <div className="col-md-4">
                {/* <span>{selectedValue.value}</span>
                <span>{selectedValue.label}</span> */}
                <Select
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  isClearable={true}
                  onChange={(event) => handleUpdate(event)}
                  // options={dropdownselect}
                  options={options.map((data) => ({
                    value: data.ID,
                    label: data.SaveAs_Name,
                  }))}
                  // value={options.find(
                  //   (obj) => obj.value == selectedValue.value
                  // )}
                  {...(selectedValue.value !== undefined ? (
                    <input value={selectedValue} />
                  ) : (
                    <input placeholder={placeHolder} />
                  ))}
                  styles={selectStyles}
                />
              </div>
              <br />

              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Width: </label>
                  <input
                    name="width"
                    type="number"
                    value={data.width}
                    className="form-control "
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label>Barcode Image Height: </label>
                  <input
                    name="height"
                    type="number"
                    value={data.height}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>

                <div className="mt-2 col-sm-4">
                  <label>Barcode Image FontSize: </label>
                  <input
                    name="fontSize"
                    type="number"
                    value={data.fontSize}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="row">
                <div className="mt-2 col-sm-4">
                  <label>Barcode Zero Fill: </label>
                  <input
                    name="zeroFill"
                    type="number"
                    value={data.zeroFill}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
                <div className="mt-2 col-sm-4">
                  <label>Save Settings Above As:</label>
                  <input
                    name="inputValue"
                    type="text"
                    value={data.inputValue}
                    className="form-control"
                    onChange={handleChange}
                  />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={handleSubmit}
                  >
                    Submit
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={handleExcelExport}
                  >
                    Export Excel
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary me-1"
                    onClick={resetpage}
                  >
                    Reset
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    onClick={downloadPdf}
                  >
                    Download PDf
                  </button>
                </div>
              </div>
              <br />
              <br />
              {formValues.map((item, index) => (
                <div key={item.SaleId}>
                  <div
                    style={{
                      width: "144px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      margin: "1rem",
                    }}
                  >
                    <span>{item.Companyname}</span>
                    <canvas
                      data-name={item.SaleId}
                      ref={(el) =>
                        (barcodeRefs.current[item.SaleId] = [
                          ...(barcodeRefs.current[item.SaleId] || []),
                          el,
                        ])
                      }
                      id={`barcode-${item.SaleId}-${index}`}
                    />
                    <div>
                      <span>
                        <strong>${item.CostPrice}</strong>
                      </span>
                      <span style={{ marginLeft: "10px" }}>
                        {item.Barcodename}
                      </span>
                      <br />
                      <span style={{ marginLeft: "10px" }}>
                        <strong>(SALEV</strong>
                        {item.SaleId})
                      </span>
                    </div>
                    {console.log("formValues======>", formValues)}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SaleBarcodeLabel;
